console.log('This is common.js')
// https://2ality.com/2019/04/nodejs-esm-impl.html#importing-commonjs-from-esm

module.exports = {
  foo: 123
}
